import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ClaimPage from './pages/ClaimPage';
import SwapPage from './pages/SwapPage';
import Navbar from './components/Navbar';
import { useAccount, useSwitchChain } from 'wagmi';
import { bsc } from 'wagmi/chains';
import { useEffect } from 'react';

function App() {
  const { isConnected, chainId } = useAccount();
  const { switchChain } = useSwitchChain();

  // Memaksa pindah ke jaringan BSC secara otomatis jika dompet terhubung namun salah jaringan
  useEffect(() => {
    if (isConnected && chainId !== bsc.id && switchChain) {
      switchChain({ chainId: bsc.id });
    }
  }, [isConnected, chainId, switchChain]);

  return (
    <Router>
      <div className="min-h-screen bg-[#111111] text-white flex flex-col items-center">
        <Navbar />
        <Routes>
          <Route path="/" element={<ClaimPage />} />
          <Route path="/swap" element={<SwapPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;